import React, { type FC } from 'react'
import { type CardBodyProps } from '../utils/types'

const CardBody: FC<CardBodyProps> = ({ data, onClick }) => {
  const { cPIssuanceId, tradeDate, settleDate, security, counterpartyName, notionalQty, discountRate, notionalQtyInUse, notionalQtyReminder } = data
  return (
        <div onClick={onClick} className="w-full p-2 bg-white shadow hover:shadow-lg transition-shadow duration-300 ease-in-out cursor-pointer">
            <p><strong>Issuance ID:</strong> {cPIssuanceId}</p>
            <p><strong>Notional Qty:</strong> {notionalQty}</p>
            <p><strong>Discount Rate:</strong> {discountRate}</p>
            <p><strong>Security:</strong> {security}</p>
            <p><strong>Trade Date:</strong> {tradeDate}</p>
            <p><strong>Settle Date:</strong> {settleDate}</p>
            <p><strong>Counterparty:</strong> {counterpartyName}</p>
            <p className='text-cyan-500'><strong>FR Total Allocation: {notionalQtyInUse}</strong> (Available: {notionalQtyReminder})</p>
        </div>
  )
}

export default CardBody
